import { useEffect, useRef, useState } from "react";
import { Play, Pause, Maximize } from "lucide-react";

const HeroMediaPreview = ({
  file,
  mediaUrl,
  height = "200px",
  width = "200px",
  noImage,
}) => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [src, setSrc] = useState(null);

  const isVideoFile = file?.type?.startsWith("video/");
  const isVideoUrl = mediaUrl && /\.(mp4|webm|ogg)$/i.test(mediaUrl);

  // 🔥 Properly handle file change
  useEffect(() => {
    let objectUrl;

    if (file) {
      objectUrl = URL.createObjectURL(file);
      setSrc(objectUrl);
    } else {
      setSrc(mediaUrl || null);
    }

    // reset video
    setIsPlaying(false);

    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.load();
    }

    return () => {
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [file, mediaUrl]);

  const togglePlay = async () => {
    if (!videoRef.current) return;

    try {
      if (videoRef.current.paused) {
        await videoRef.current.play();
        setIsPlaying(true);
      } else {
        videoRef.current.pause();
        setIsPlaying(false);
      }
    } catch (err) {
      console.error("Video play failed:", err);
    }
  };

  const openFullscreen = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.requestFullscreen) video.requestFullscreen();
    else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
  };

  if (isVideoFile || isVideoUrl) {
    return (
      <div className="position-relative" style={{ width }}>
        <video
          key={src}                // 🔥 FORCE RE-MOUNT
          ref={videoRef}
          src={src}
          muted
          playsInline
          controls={false}
          preload="metadata"
          className="rounded border"
          style={{ height, width, objectFit: "contain" }}
          onEnded={() => setIsPlaying(false)}
        />

        {/* Play / Pause */}
        <button
          type="button"
          onClick={togglePlay}
          className="btn btn-dark position-absolute top-50 start-50 translate-middle rounded-circle"
        >
          {isPlaying ? <Pause size={20} /> : <Play size={20} />}
        </button>

        {/* Fullscreen */}
        <button
          type="button"
          onClick={openFullscreen}
          className="btn btn-dark position-absolute top-0 end-0 m-2 rounded-circle"
        >
          <Maximize size={18} />
        </button>
      </div>
    );
  }

  return (
    <img
      src={src || noImage}
      alt="Hero Media"
      className="rounded border"
      style={{ height, width, objectFit: "contain" }}
    />
  );
};

export default HeroMediaPreview;
